import * as React from 'react';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-html';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../hooks/useCartDiscounts/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import { PriceSectionContainer } from '../../../components/PriceSection/PriceSectionContainer.js';
import '@grandvisionhq/content';
import { useSunglassesPriceFrom } from '../../hooks/use-sunglasses-price-from.js';

const SunglassesPriceSection = ()=>{
    const { fromPricePrefix , shouldDisplayFromPrice  } = useSunglassesPriceFrom();
    return /*#__PURE__*/ React.createElement(PriceSectionContainer, {
        shouldDisplayFromPrice: shouldDisplayFromPrice,
        fromPricePrefix: fromPricePrefix
    });
};

export { SunglassesPriceSection };
//# sourceMappingURL=SunglassesPriceSection.js.map
